// extracted by mini-css-extract-plugin
module.exports = {"subheader":"ProductConfigurationSubHeader_subheader__1Uta9","questionTooltip":"ProductConfigurationSubHeader_questionTooltip__3PMEe"};